module.exports = __webpack_public_path__ + "static/media/carousel-img2.7c98d111.png";